// CLARTEXT SPRACHE – Englische Mitarbeiter-UI (AP-LANG-EN, Juni 2026).
// Echte englische Übersetzung der Monteur-App-UI (KEIN Re-Export mehr von de.js).
// Schlüssel-IDENTISCH zu de.js; fehlende Schlüssel fallen über createT auf Deutsch
// zurück. Weltinhalte (Welt-Titel, Fragen, Antwortoptionen, GBU-/BA-Texte) sind
// Daten und kommen über den Read-Resolver (`display`), NICHT aus dieser Datei.
const en = {
  // Gemeinsame
  "common.loading": "Loading…",

  // PIN-Login (/monteur/login)
  "login.eyebrow": "Sign in",
  "login.title": "Your PIN",
  "login.subtitle": "Company code + 4-digit PIN from your manager.",
  "login.companyCodeLabel": "Company code",
  "login.companyCodePlaceholder": "e.g. LUMPE",
  "login.submitting": "Signing in…",
  "login.backAria": "Back to login",
  "login.errorNoCode": "Please enter the company code first.",
  "login.errorUnknown": "Company or PIN not recognised.",

  // Aufgabenliste (/monteur)
  "tasks.companyFallback": "Your company",
  "tasks.portalSubtitle": "Training portal",
  "tasks.loggedInAs": "Signed in as",
  "tasks.heading": "Your tasks",
  "tasks.openCount": "{count} open",
  "tasks.emptyToday": "No open tasks today.",
  "tasks.newBanner": "You have {count} new training assignment(s) since your last visit.",
  "tasks.newBadge": "New",
  "tasks.newBannerDismissAria": "Dismiss notice",
  "tasks.backAria": "Back to overview",
  "home.tasksTitle": "Training assignments",
  "home.searchTitle": "Reference guide",
  "home.searchSubtitle": "Quickly look up safety info",
  "home.hspTitle": "Skin protection plan",
  "home.hspSubtitle": "Skin protection and glove selection at a glance",
  "home.driverTitle": "Driver's licence check",
  "home.driverOpen": "Please submit your driver's licence",
  "home.driverSubmitted": "Waiting for company review",
  "home.driverUpToDate": "Currently valid",
  "home.settingsTitle": "Settings",
  "home.settingsSubtitle": "Manage email & language",
  "home.comingSoon": "Coming soon",
  "home.newBubbleAria": "{count} new training assignments",
  "settings.profileTitle": "Profile",
  "settings.profileHint": "Name and company are maintained by your company.",
  "settings.emailTitle": "Email for notifications",
  "settings.emailPurpose": "Used solely to inform you about new training assignments.",
  "settings.emailPlaceholder": "name@example.com",
  "settings.emailSave": "Save",
  "settings.emailSaved": "Saved",
  "settings.emailInvalid": "Please enter a valid email address.",
  "settings.emailRemoveHint": "Clear the field and save to opt out again.",
  "settings.saveError": "Saving failed. Please try again.",
  "settings.privacyLink": "Privacy policy",
  "settings.consentLabel": "I would like to be notified by email about new training assignments.",
  "settings.languageTitle": "Language",
  "settings.langNotBooked": "Greyed-out languages have not yet been booked by your company. Talk to your boss if you would like to use one of them.",
  "tasks.quickLookup": "Quick lookup",
  "tasks.doneHeading": "Already completed",
  "tasks.dueLabel": "Due",
  "tasks.doneAtLabel": "Completed on",
  "tasks.logoutAria": "Sign out",

  // CLARTEXT · A1 (Feb 2026) – Posting-obligation display (Mitarbeiter-Link + page).
  "aushang.linkTitle": "Statutory posting requirements",
  "aushang.linkSubtitle": "Official original texts",
  "aushang.pageTitle": "Statutory posting requirements",
  "aushang.categoryAllgemein": "General statutory basis",
  "aushang.categoryDguv": "DGUV regulations and technical rules",

  // Aufgabendetail (/monteur/aufgabe/:id)
  "aufgabe.notFound": "Task not found.",
  "aufgabe.wrongOne": "One answer was not correct. Please answer again.",
  "aufgabe.wrongMany":
    "{count} answers were not correct. Please answer again.",
  "aufgabe.saveFailed": "Saving failed. Please try again.",
  "aufgabe.doneTitle": "Done!",
  "aufgabe.doneBody":
    "The training “{title}” is complete. Your record has been created automatically and is stored in your company's audit file.",
  "aufgabe.backToTasks": "Back to my tasks",
  "aufgabe.stepContent": "Content",
  "aufgabe.stepQuestion": "Question {current} of {total}",
  "aufgabe.backShort": "Tasks",
  "aufgabe.readCalm": "Please read through it carefully.",
  "aufgabe.questionsFollow": "Then {count} short comprehension questions follow.",
  "aufgabe.questionLabel": "Comprehension question {current} / {total}",
  "aufgabe.wrongAgain":
    "This answer was not correct on your last attempt. Please choose again.",
  "aufgabe.prev": "Back",
  "aufgabe.saving": "Saving…",
  "aufgabe.finish": "Complete training",
  "aufgabe.toQuestions": "Go to the questions",
  "aufgabe.next": "Next",

  // Nachschlage-Suche (Komponente MonteurWeltSuche)
  "suche.placeholder": "Look up – e.g. “battery”, “goggles”, “ladder”…",
  "suche.inputAria": "Search documentation world",
  "suche.matchIn": "Match in {label}:",
  "suche.empty": "No matching documentation world found.",
  "suche.emptyHint": "Try another word, e.g. “PPE” or “bandage”.",

  // Welt-Nachschlagewerk (/monteur/welt/:id) – NUR UI-Rahmen/Labels.
  "welt.headerTitle": "Look up",
  "welt.backAria": "Back",
  "welt.errorNotAvailable": "This documentation world is currently unavailable.",
  "welt.errorLoad": "The world could not be loaded.",
  "welt.backToTasks": "Back to my tasks",
  "welt.loading": "Loading world…",
  "welt.doctype": "Reference",
  "welt.versionLabel": "Version",
  "welt.gbuTitle": "Risk assessment",
  "welt.noHazards": "No individual hazards documented.",
  "welt.residualRisk": "Residual risk:",
  "welt.measureTechnical": "Technical",
  "welt.measureOrganizational": "Organisational",
  "welt.measurePersonal": "Personal",
  "welt.responsible": "Responsible:",
  "welt.baTitle": "Operating instructions",
  "welt.baSubtitle": "Per TRBS / GefStoffV / BetrSichV",
  "welt.mainHazards": "Main hazards",
  "welt.protectiveMeasures": "Protective measures & rules of conduct",
  "welt.emergency": "In an emergency",
  "welt.firstAid": "First aid",
  "welt.disposalHazmat": "Storage & disposal",
  "welt.disposalVehicle": "Parking",
  "welt.disposalDefault": "Decommissioning",
  "welt.instructionTitle": "Training",
  "welt.instructionSubtitle": "Per DGUV V1 §4",
  "welt.visualTitle": "Visual learning aids",
  "welt.visualSubtitle":
    "Support understanding – they do not change any content, records or PDFs",
  "welt.questionsTitle": "Comprehension questions",
  "welt.questionsSubtitle":
    "{count} questions — self-check, without marking the correct answer",
  "welt.maintenanceTitle": "Inspection & maintenance notes",
  "welt.maintenanceSubtitle": "Per BetrSichV / UVV",
  "welt.performedBy": "Performed by:",
  "welt.recommendedCheck": "Recommended expert inspection:",
  "welt.recurrenceTitle": "Recurrence cycles",
  "welt.recurrenceSubtitle": "Per module – monitored automatically by the system",
  "welt.recurrenceUnterweisung": "Training",
  "welt.recurrenceGbuReview": "Risk assessment – review",
  "welt.recurrenceWartung": "Maintenance / inspection",
  "welt.recurrence.none": "–",
  "welt.recurrence.einmalig": "One-time",
  "welt.recurrence.monatlich": "Monthly",
  "welt.recurrence.vierteljaehrlich": "Quarterly",
  "welt.recurrence.halbjaehrlich": "Semi-annually",
  "welt.recurrence.jaehrlich": "Annually",
  "welt.recurrence.zwei_jahre": "Every 2 years",

  // Aufgaben-Status (StatusBadge)
  "status.offen": "Open",
  "status.erledigt": "Completed",
  "status.ueberfaellig": "Overdue",

  // Feste Abschnitts-Überschriften (content[].heading). Lookup-Schlüssel bleibt der
  // DEUTSCHE Quell-Heading; nur der WERT ist englisch. DB/Beweiskette bleiben deutsch.
  "contentHeading.Worum geht es?": "What is this about?",
  "contentHeading.Welche Gefahren bestehen?": "What hazards are there?",
  "contentHeading.Vor Arbeitsbeginn beachten": "Before starting work",
  "contentHeading.Während der Arbeit beachten": "During work",
  "contentHeading.Nach der Arbeit beachten": "After finishing work",

  // UI-/Präsentationslabels der visuellen Lernschicht (VLOs).
  "vlo.safetySymbols.title": "Safety symbols",
  "vlo.safetySymbols.hint":
    "These symbols support the training. The text is always authoritative.",
  "vlo.psaSummary.title": "PPE summary",
  "vlo.hazardMarkers.title": "Hazard markings",
  "vlo.learningFocus.title": "Learning focus",
  "vlo.richtigFalsch.title": "Right & Wrong",
  "vlo.richtigFalsch.correct": "Right",
  "vlo.richtigFalsch.wrong": "Wrong",

  // PRINT.1 (Juni 2026) – Plakat-Labels (UI-Hülsen des gedruckten Plakats).
  "plakat.eyebrow": "Safety briefing poster",
  "plakat.subtitle": "Work safely – the key rules at a glance",
  "plakat.symbols": "Safety signs",
  "plakat.hazards": "Hazards",
  "plakat.richtigFalsch": "Right & Wrong",
  "plakat.correct": "Right",
  "plakat.wrong": "Wrong",
  "plakat.psa": "Personal protective equipment (PPE)",
  "plakat.rules": "Most important rules",
  "plakat.qrTitle": "Open the world directly",
  "plakat.qrText": "Scan the QR code with your phone, enter your PIN – this documentation world opens immediately.",
  "plakat.footerHint": "This poster supports the briefing. The full briefing remains authoritative.",
  "plakat.moreInFull": "More content in the full briefing",

  // AP-PLAKAT-UX (Juni 2026) – group subheadings + multi-page.
  "plakat.hazardsSub": "What can happen?",
  "plakat.correctSub": "How to work safely.",
  "plakat.wrongSub": "How not to work.",
  "plakat.continued": "continued",
  "plakat.page": "Page",
};

const enExtra = {
  "common.back": "Back",
  "common.notEnabled": "This view is not enabled for your company.",

  "aushang.kicker": "Statutory postings",
  "aushang.intro": "Links to the official original texts. The operator maintains this list centrally; updates are reviewed before they are published.",
  "aushang.loadError": "The postings could not be loaded.",
  "aushang.listLoading": "Loading postings…",
  "aushang.listEmpty": "No entries yet — the operator maintains this list via the operations console.",
  "aushang.categoryEmpty": "No entries in this category.",

  "hsp.kicker": "Hand protection plan",
  "hsp.titleFallback": "Skin and hand protection plan",
  "hsp.loadError": "The hand protection plan could not be loaded.",
  "hsp.empty": "There is currently no hand protection plan for this work area.",
  "hsp.plakatCreatingTitle": "Poster is being created",
  "hsp.plakatCreatingText": "On first access the images are generated — this can take up to two minutes. Afterwards the poster is available instantly.",
  "hsp.plakatFailedTitle": "The poster could not be created.",
  "hsp.plakatFailedHint": "Please try again. The text view is available below.",
  "hsp.plakatReload": "The poster could not be loaded just now. Please reload the page.",
  "hsp.plakatTimeout": "Creation is taking longer than expected. Please try again later.",
  "hsp.plakatRetry": "The poster could not be created. Please try again.",
  "hsp.plakatLoadFailed": "The poster could not be loaded just now.",
  "hsp.plakatImgError": "The poster image could not be displayed.",
  "hsp.plakatAlt": "Hand protection plan poster",
  "hsp.plakatLoadingAria": "Poster is loading",
  "hsp.textOpen": "Show as text",
  "hsp.textClose": "Close text view",
  "hsp.thWas": "What",
  "hsp.thWann": "When",
  "hsp.thWomit": "With what",
  "hsp.thWie": "How",
  "hsp.firstAidTitle": "First aid after skin contact",
  "hsp.gsvOne": "1 hazardous substance in this area",
  "hsp.gsvMany": "{count} hazardous substances in this area",
  "hsp.gsvMenge": "Quantity on site:",
  "hsp.gsvHSaetze": "H statements:",
  "hsp.psaHandschutz": "Hand protection",
  "hsp.psaAtemschutz": "Respiratory protection",
  "hsp.psaAugenschutz": "Eye protection",
  "hsp.psaKoerperschutz": "Body protection",
  "hsp.psaErsteHilfe": "First aid after skin contact",
  "hsp.psaAetzReiz": "Corrosive/irritant effect",
  "hsp.psaSensibilisierung": "Sensitisation",
  "hsp.psaPSaetze": "P statements",

  "fuehrerschein.title": "Driving licence check",
  "fuehrerschein.loadError": "The task could not be loaded.",
  "fuehrerschein.notApplicable": "No driving licence check is currently scheduled for you.",
  "fuehrerschein.categoriesTitle": "Your vehicle types",
  "fuehrerschein.categoriesSubtitle": "Your employer has assigned these vehicle types to you.",
  "fuehrerschein.categoriesEmpty": "No categories assigned.",
  "fuehrerschein.upToDateTitle": "Driving licence currently valid",
  "fuehrerschein.upToDateText": "No check is due at the moment.",
  "fuehrerschein.nextDue": "Next check due on",
  "fuehrerschein.lastDecision": "Last approval:",
  "fuehrerschein.submittedTitle": "Submission successful",
  "fuehrerschein.submittedText": "Your licence photo and the declaration are now with your employer for review.",
  "fuehrerschein.submittedAt": "Submitted on",
  "fuehrerschein.declarationTitle": "Declaration",
  "fuehrerschein.declarationAccept": "I have read the declaration and confirm it.",
  "fuehrerschein.photoFrontTitle": "Licence photo: front",
  "fuehrerschein.photoFrontHint": "Please photograph the front of your driving licence clearly (name and expiry date visible).",
  "fuehrerschein.photoBackTitle": "Licence photo: back",
  "fuehrerschein.photoBackHint": "Please photograph the back of your driving licence clearly (category table visible).",
  "fuehrerschein.previewFrontAlt": "Preview licence front",
  "fuehrerschein.previewBackAlt": "Preview licence back",
  "fuehrerschein.otherPhoto": "Different photo",
  "fuehrerschein.remove": "Remove",
  "fuehrerschein.pickFront": "Capture front or choose a file",
  "fuehrerschein.pickBack": "Capture back or choose a file",
  "fuehrerschein.pickLimits": "Max. 12 MB · JPEG, PNG, WEBP, HEIC",
  "fuehrerschein.submit": "Submit",
  "fuehrerschein.submitting": "Submitting…",
  "fuehrerschein.submitSuccess": "Submission successful.",
  "fuehrerschein.submitFailed": "Submission failed. Please try again.",
  "fuehrerschein.errFormat": "Unsupported image format. Please choose JPEG, PNG, WEBP, HEIC or HEIF.",
  "fuehrerschein.errSize": "File too large. Maximum: 12 MB.",
  "fuehrerschein.ocrPreparing": "Automatic reading aid is being prepared…",
  "fuehrerschein.ocrUnavailable": "OCR temporarily unavailable — please check the licence manually.",
  "fuehrerschein.ocrBannerStrong": "Automatic transcript",
  "fuehrerschein.ocrBannerRest": " — no review by CLartext, does not replace a visual check.",
  "fuehrerschein.ocrName": "Name (as read)",
  "fuehrerschein.ocrExpiry": "Expiry date (as read)",
  "fuehrerschein.ocrClasses": "Categories (as read)",
};
Object.assign(en, enExtra);

export default en;
